// extracted by mini-css-extract-plugin
export default {"container":"card_container__84Rbw","image":"card_image__OPT84","info":"card_info__ACyvQ"};